import React from 'react';
import Utils from "../../common/Utils";
import CardTile from "../../components/CardTile/CardTile";
import {FarmersEndpoints, MiscEndpoints, USSDEndpoints} from "../../common/ProxyEndpoints";
import SessionStateManager from "../../common/SessionStateManager";
import HTML from '../../common/HtmlHelpers';
import TTLProxy from "../../common/TTLAsyncProxy";
import {Badge, Button} from 'reactstrap';
import {CreationLineChart} from "./DashboardCommon";
import DocumentTitle from 'react-document-title';
import {RequestTimeFrame} from "../../common/Constants";
import TractorRequestBuilder from "../../components/TractorRequestBuilder/TractorRequestBuilder";

/**
 * Dashboard - Farmer View
 */
export default class DashboardFarmer extends React.Component {

    constructor(props){
        super(props);

        const session = new SessionStateManager('farmer_dashboard', false);
        this.session = session;
        this.proxy = TTLProxy.getInstance();
        this.state = {

            isLoaded: session.getState('isLoaded',false),
            faulted: session.getState('faulted',false),
            stats: session.getState('stats',{

                requests: {

                    //  Total number of requests made by the farmers of the FBO
                    total: 0,

                    //  The total number of assigned requests
                    assigned: 0,

                    //  The total number of completed requests
                    completed: 0,

                    //  The total number of unassigned requests
                    unassigned: 0,

                    //  Total cancelled requests
                    cancelled: 0,

                    //  The total number of acres assigned
                    totalAssignedAcres: 0,

                    //  The total number of hectares assigned
                    totalAssignedHectares: 0,

                    //  The total number of acres completed
                    totalCompletedAcres: 0,

                    //  The total number of hectares completed
                    totalCompletedHectares: 0,

                    //  Total payments made
                    totalPayments: 0,

                    //  Total number of paid but unassigned requests
                    totalPaidUnassigned: 0,

                    //  The creation statistics
                    creation: {

                        //  Total requests today
                        today: 0,

                        //  Total requests this week
                        week: 0,

                        //  Total requests this month
                        month: 0,

                        //  Total requests this year
                        year: 0,
                    }
                }
            }),

            //  Request Order Chart Statistics
            requestsOrderStats: null,

            //  USSD Services
            services: [],

            //  The state of dialogs
            dialogStates: {},

            //  Indicates busy state
            isBusy: false,

            //  Indicates creating state
            isCreating: false
        };

        this._isMounted = false;
    }


    fetchDashboardStats(){
        return this.proxy.processRequest(MiscEndpoints.getFarmerDashboardStats(this.getFarmerId())).then(response => response.getPayload());
    }

    fetchRequestAnalytics(){
        return this.proxy.processRequest(FarmersEndpoints.getRequestStats(this.getFarmerId(),RequestTimeFrame.Month , { min : 4, max: 4} , 1)).then(response => response.getPayload());
    }

    fetchUSSDServices(){

        const endpoint = USSDEndpoints.getUSSDServices();
        endpoint.include = ["pricing"];
        return this.proxy.processRequest(endpoint).then(response => response.getPayload());
    }

    setStateSafe(state,callback){

        if(this._isMounted){
            this.setState(state,callback);
        }

    }

    loadState(){

        const proxy= this.proxy;
        const me = this;

        return Promise.all([

            this.fetchDashboardStats().then(payload => {

                me.setStateSafe({
                    stats: payload,
                });

            }),

            this.fetchRequestAnalytics().then(payload => {

                me.setStateSafe({
                    requestsOrderStats: payload
                });

            }),

            this.fetchUSSDServices().then(services => {

                me.setStateSafe({
                    services: services
                });

            })

        ]).then(values => {

            me.setState({
                faulted: false,
                isLoaded: true
            });

        }).catch(err => me.enterErrorState(err));

    }

    enterErrorState(err){

        alert(err);

        //  Show warning message
        HTML.toastWarning(Utils.getResponseError(err));

        //  Set the state
        this.setState({ faulted: true });

    }

    getFarmerId(){
        return this.proxy.getUserInfo().farmer.id;
    }


    persistSession(){

        this.session.putStateFrame({
            isLoaded: this.state.isLoaded,
            faulted: this.state.faulted,
            stats: this.state.stats
        }).save();
    }

    componentWillUnmount(){
        this.persistSession();
        this._isMounted = false;
    }

    componentDidMount(){

        this._isMounted = true;

        //
        if(!this.state.isLoaded  || this.state.faulted)
            return this.loadState();

    }

    componentWillMount(){

        //  TODO: Load stuffs here

    }

    navigateUrl(url , args){
        this.props.history.push(url,args);
    }

    renderModals(){

        return (<React.Fragment>

            <TractorRequestBuilder onBuildRequest={() => ({ query: { farmer: this.getFarmerId() } })}
                                   fetchFarmers={() => ([ this.proxy.getUserInfo().farmer ])}
                                   ref={r => this._addRequest = r}
                                   onRequestCreated={() => this.loadState()}/>

        </React.Fragment>);
    }

    render(){

        const state = this.state;
        const stats = state.stats;
        const requestsCreateChart = state.requestsOrderStats ? state.requestsOrderStats.requests : null;

        return (<DocumentTitle title={"Farmer Dashboard"}>

            <div>
                <div className="container-fluid">
                    <div className="animated fadeIn">

                        <div className="row content-frame">

                            <div className="col-sm-8 col-md-3">

                                <CardTile classes="card-inverse card-primary"
                                          icon="icon-docs"
                                          title="Total No. Requests"
                                          value={stats.requests.total}
                                          tooltipTitle="Requests"
                                          tooltipContent="Indicates the total number of tractor requests made"
                                          navigateText="Click to see"
                                          onClick={() => this.navigateUrl('/requests')}/>

                            </div>

                            <div className="col-sm-8 col-md-3">

                                <CardTile classes="card-inverse card-danger"
                                          icon="fa fa-hourglass"
                                          title="Pending Requests"
                                          value={stats.requests.totalPaidUnassigned}
                                          tooltipTitle="Pending Requests"
                                          tooltipContent="Indicates the total number of paid but unassigned tractor requests."
                                          navigateText="Click to see"
                                          onClick={() => this.navigateUrl(`/requests?paid_only=true&request_status=unassigned`) }/>

                            </div>

                            <div className="col-sm-8 col-md-3">

                                <CardTile classes="card-inverse card-success"
                                          icon="fa fa-toggle-on"
                                          title="Assigned Requests"
                                          value={stats.requests.assigned}
                                          tooltipTitle="Assigned Requests"
                                          tooltipContent="Indicates the total number of assigned tractor requests."
                                          navigateText="Click to see"
                                          onClick={() => this.navigateUrl(`/requests?request_status=assigned`) }/>

                            </div>

                            <div className="col-sm-8 col-md-3">

                                <CardTile classes="card-inverse card-warning"
                                          icon="fa fa-check"
                                          title="Completed Requests"
                                          value={stats.requests.completed}
                                          tooltipTitle="Completed Requests"
                                          tooltipContent={`Indicates the total number of completed tractor requests.`}
                                          navigateText="Click to see"
                                          onClick={() =>  this.navigateUrl(`/requests?request_status=completed`) }/>
                            </div>

                        </div>



                    </div>
                </div>
                <div style={{backgroundColor: 'white'}}>
                    <div className="container-fluid" >

                        <div className="stats-bottom animated fadeIn" >
                                <div>
                                    <div className="row">

                                        <div className="col-md-4">
                                            <p>The chart beside shows the tractor services you requested</p>
                                            <b>Recently Requested</b>
                                            <hr/>

                                            <h6><Badge pill={true}>Today: {stats.requests.creation.today}</Badge></h6>
                                            <h6><Badge pill={true}>This Week: {stats.requests.creation.week}</Badge></h6>
                                            <h6><Badge pill={true}>This Month: {stats.requests.creation.month}</Badge></h6>

                                        </div>

                                        <div className="col-md-8">
                                            <div className="card">
                                                <div className="card-body">
                                                    <CreationLineChart fill={false} labelFormat="MMM YYYY" title="Requests (Ordered)" data={requestsCreateChart} height={180}/>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <Button className="btn-green" block style={{ marginBottom: 10 }} onClick={() => this._addRequest.show({ farmer: this.proxy.getUserInfo().farmer })}><i className="fa fa-plus" /> Request Tractor Service</Button>

                                </div>
                        </div>

                    </div>
                </div>
                {this.renderModals()}
            </div>
        </DocumentTitle>);
    }

}


// WEBPACK FOOTER //
// ./src/views/Dashboard/DashboardFarmer.js